import React from 'react'
import Layout from '../../../partials/layout'
import { ERCButton } from 'components/button'
import { ERCText } from 'components/text'
import Cards, { MarkFrame } from "../frames/index"
import { useDispatch } from 'react-redux'
import { showModal } from 'store/reducers/modal'
import Counsellorform from 'components/counsellorapointment/counsellorform'
import abstractLine from '../../../assets/images/gandcImg/abstract-line.svg'
import iconContainer from '../../../assets/images/gandcImg/icon-container.svg'
import rectangle5187 from '../../../assets/images/gandcImg/rectangle-5187.svg'
import gandcIcon1 from '../../../assets/images/gandcImg/icon-1.svg'
import gandcIcon2 from '../../../assets/images/gandcImg/icon-2.svg'
import gandcMaskGroup from '../../../assets/images/gandcImg/mask-group.svg'
import gandcIcon1Alt from '../../../assets/images/gandcImg/icon-1-alt.svg'
import gandcIcon5 from '../../../assets/images/gandcImg/icon-5.svg'
import gandcIcon6 from '../../../assets/images/gandcImg/icon-6.svg'

const Gandc = () => {
  const dispatch = useDispatch()

  return (
    <Layout mqcolor='#129748' footerColor="#129748">
      <div className='w-full h-[890px] bg-[#B7FFD4;]' >
          
         <img className="absolute left-[14.5%] pt-[7%]" src={abstractLine} alt='shakes'/>
          <div className='flex mx-auto mt-[120px] p-[10px] rounded-[5px] w-[66%] bg-[#ffffff]'>
          <img src={iconContainer} alt="swift"/>
          <div className='flex pt-[20px] space-x-[7px] pl-[5px]'>
          <ERCText align='center' color='#129748' size='48px' weight='700'>
            Empowering   
          </ERCText>
          <ERCText size='48px' weight='700'>
          Emotional Well-being
          </ERCText>
          </div>
          </div>
       
      
     <div className='text-center my-[40px]'>
      <ERCText size='32px' weight='600'>
      Empowering Individuals to Thrive: Compassionate Counselling 
      </ERCText>
      <div className='mt-[10px]'>
      <ERCText size='32px' weight='600'>
      for Mental Well-being
      </ERCText>
      </div>
      </div>

      <div className='flex justify-center align-center gap-[10px] my-[40px]'>
      <ERCButton width='auto' height='auto' size='18px' weight="600" color='#FFD600' bgcolor='#129748' p="15px" onClick={() => (dispatch(showModal({ content: <Counsellorform/>})))}>Chat with A Counsellor</ERCButton>
      <ERCButton width='auto' height='auto' p="15px" size='18px' weight="600" color='#262626' bgcolor='#ffffff'>Find A Counsellor</ERCButton>

      </div>
      <div className='relative'>
      <img className="w-[80%] h-[447px] mx-auto" src={rectangle5187} alt=""/>
      </div>
      </div>

      <div className='w-full flex gap-[40px] mt-[50px] p-[50px]'>
      <div className='flex flex-col'>
                            <ERCText size="20px" weight="700" color={'#00844B'} lHeight="24px"  >ABOUT US</ERCText>
                            <hr width='11%' align='left' style={{ border: "1.5px solid #FFD600" }} />
                            <div className='my-[20px]'>
                            <ERCText size='40px' weight='600' lHeight='48px'>Compassionate Counselling: Your Path to Emotional Wellness</ERCText>
                            </div>
                        <ERCText weight="400" size="16px" align="justify" color="#525252" lHeight="24px" >welcome!! At our center, we understand the complexities of navigating life's challenges, and we are here to support you every step of the way. Our team of experienced counselors and mental health professionals is dedicated to creating a safe and support environment where you can explore your thoughts, feelings and concerns openly and without judgement.  </ERCText>

                        <div className='mt-[100px]'>
                        <ERCButton weight={'700'} g={'8px'} size="16px" p={'16px 24px'} showArrow color="#FFD600" bgcolor='#129748' width='190px' height='56px' onClick={() => (dispatch(showModal({ content: <Counsellorform/>})))}>Book A Session</ERCButton>
                        </div>
                        </div>        
        <div className='flex flex-col gap-[15px] pt-[100px]'>
        <MarkFrame msg={"we are committed to providing accessible, compassionate, and professional counselling services to students across Lagos State "} />
        <MarkFrame msg={"we believe that everyone deserves access to quality mental health care, and we are proud to serve as atrusted partner in your journey towards emotional wellness and personal growth "} />
        <MarkFrame msg={"whether you are feeling personal struggles academic challenges or simply seeking guidance and support our counselors are here to help you gain insight. build resilence, and empower you to lead a fulfilling and meaningful life."} />
        </div>
      </div>
<div>
  <div className='flex flex-col justify-center items-center mt-[100px]'>

<ERCText size="14px" weight="700" color={'#00844B'} lHeight="20px"  >HOW IT WORKS</ERCText>
<hr width='4%' align='left' style={{ border: "1px solid #FFD600" }} />

<div className='my-[20px]'>
<ERCText size='40px' weight='700' lHeight='48px'>
  Counselling Process
</ERCText>
</div>
  </div>

      <div className='w-full flex flex-wrap items-center justify-center gap-[25px] border-2-red p-[40px]'>
       
        <Cards
        img={gandcIcon1}
        header={"Show interest and book Appointment"} description={"Express interest in counselling by booking an appointment through the web app. Provide your name, phone number, school, and district. Additionally, select the category of the topic you want to discuss with the counsellor (e.g., bullying, special needs, assault)."} />

        <Cards
         paddingBottom="120px"
        img={gandcIcon2}
        header={"Notification to Counselor"} description={"Once an appointment is booked, the counselor receives a notification through the app, informing them of the appointment request."} />

        <Cards
        paddingBottom="120px"
        img={gandcMaskGroup}
        header={"Acceptance by Counsellor"} description={"The counsellor reviews the appointment request and accepts it through the app, indicating their availability to hold the counselling session."} />
        <Cards
        img={gandcIcon1Alt}
        header={"Confirmation and Meeting Details"} description={"After accepting the appointment, the counsellor sends confirmation to you, along with the date, time, and a meeting link for the counselling session."} />
        <Cards
        img={gandcIcon5}
        header={"Preparation by User"} description={"Prepare for the counselling session, ensure you have a stable internet connection and a quiet, private space for the meeting."}
         paddingBottom="65px"
        />
        <Cards
        img={gandcIcon6}
        header={"Counselling Session"} description={"At the scheduled time, both you and the counsellor join the virtual counselling session using the provided meeting link. During the session, the counsellor provides support, guidance, and resources to address your concerns effectively."}
         paddingTop="35px"
        />
      </div>
      </div>
    </Layout>
  )
}

export default Gandc
